import { Steps, message } from 'antd';
import TcTooltip from 'components/UI/Tooltip/TcTooltip';
import TcButton from 'components/UI/button/TcButton';
import TcPageTitle from 'components/UI/pageTitle/TcPageTitle';
import AddNewOrderRow from 'components/pages/dashboard/ParcelOrder/components/order/AddNewOrderRow';
import { isAllPackagesCompelete } from 'components/pages/dashboard/ParcelOrder/components/orderMethods/components/parcelOrderFunctions';
import ParcelOrderSubstation from 'components/pages/dashboard/ParcelOrder/components/substation/ParcelOrderSubstation';
import BranchParcelOrderPrice, { priceTypeBranch } from 'components/pages/dashboard/parcelOrderForBranch/components copy/BranchOrder/BranchParcelOrderPrice';
import BranchOrderMethods from 'components/pages/dashboard/parcelOrderForBranch/components copy/orderMethods/BranchOrderMethods';
import OrderSummery from 'components/pages/dashboard/parcelOrderForBranch/components copy/orderSummery/OrderSummery';
import BranchOrderRow from 'components/pages/dashboard/parcelOrderForBranch/components copy/origin/components/BranchOrderRow';
import { getBranchPayloadFromPackages, getPayloadFromPackages, getPayloadPricingV4 } from 'components/pages/dashboard/parcelOrderForBranch/components copy/parcelOrderFunctions';
import endpointUrls from 'global/Constants/endpointUrls';
import routes from 'global/Constants/routes';
import { IBackendGetGeneric } from 'global/Models/globalModels';
import { branchPackageCreate, omOrderServices, orderBranchPayload, orderPaylaod, packageCreate, pricingV4 } from 'global/Models/omOrderModel';
import { handleApiThenGeneric } from 'global/helperFunctions/handleApiThen';
import { localApiCatcher } from 'global/helperFunctions/localApiCatcher';
import ApiService, { errorResponse } from 'global/utils/ApiService';
import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import { getOrderSteps } from '../ParcelOrder/components/parcelOrderFunctions';

const emptyPackage: branchPackageCreate = {
  senderAddress: undefined,
  senderClient: undefined,
  localDate: Date.now(),
  receiverAddress: undefined,
  receiverClient: undefined,
  package: [],
  uuid: uuid(),
};

export type orderMethodsState = {
  paymentTypeId?: number;
  pickupTypeId?: number;
  deliveryTypeId?: number;
  selectedDate?: string;
  selectedFromHour?: string;
  selectedToHour?: string;
  serviceId?: number;
  haveCOD: boolean;
  paymentSide: 'sender' | 'receiver' | 'senderReceiver' | 'cashAndPayInPlace';
  paymentTypeError?: string;
  cashAmount: number | string;
  customerSubstationCode?: string;
};

export type packPallet = {
  weight: number;
  packageValue: number;
  length: number;
  width: number;
  height: number;
  enableLabelPrivacy: boolean;
  paymentTypeId: number;
  pickupTypeId: number;
  deliveryTypeId: number;
  pickupStartTime: string;
  pickupEndTime: string;
  cod: number;
  cashAmount: number;
  packageContentId: number;
  packagingGroupId: number;
};

const BranchParcelOrder: FC = () => {
  //hooks

  const { pathname } = useLocation();
  const isLocker = pathname.includes('locker');
  const history = useHistory();

  //states
  const [packages, setPackages] = useState<packageCreate[]>([{ ...emptyPackage }]);
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [orderMethods, setOrderMethods] = useState<orderMethodsState>({ haveCOD: false, paymentSide: 'receiver', cashAmount: '0', pickupTypeId: 10, deliveryTypeId: 10 });
  const [loading, setLoading] = useState<boolean>(false);
  const [priceList, setPriceList] = useState<priceTypeBranch>();
  const [priceLoading, setPriceLoading] = useState<boolean>(false);
  const [serviceLoading, setSerivceLoading] = useState<boolean>(false);
  const [orderServices, setOrderServices] = useState<omOrderServices>([]);
  const [traceCode, setTraceCode] = useState<string>('');
  const [cashAmount, setCashAmount] = useState<number>();

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (orderServices.length > 0) getPrice();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [orderServices, orderMethods]);

  //functions
  const addNewRow = () =>
    setPackages((prevState) => {
      const temp = [...prevState];
      temp.push({
        senderAddress: undefined,
        senderClient: undefined,
        receiverAddress: undefined,
        receiverClient: undefined,
        package: [],
        uuid: uuid(),
      });
      return temp;
    });
  const copyByIndex = (index: number) => {
    //create a copy of row index but dont put it at the end of array, place it in the next index
    setPackages((prevState) => {
      const temp = [...prevState];
      temp.splice(index + 1, 0, { ...temp[index], uuid: uuid() });
      return [...temp];
    });
  };
  const deleteRow = useCallback(
    (index: number) =>
      setPackages((prevState) => {
        const tempPacks = prevState.filter((_pack: any, idx) => idx !== index);
        return tempPacks;
      }),
    []
  );

  const newReceiverRow = () => {
    //create a copy of last row of packages but delete receiver
    setPackages((prevState) => {
      const temp = [...prevState];
      temp.push({
        ...prevState[prevState.length - 1],
        receiverAddress: undefined,
        receiverClient: undefined,
        uuid: uuid(),
      });
      return temp;
    });
  };

  console.log('cashAmount braaaaanch,', cashAmount);

  const nextStep = () => {
    if (currentStep === 0 && !isAllPackagesCompelete(packages, isLocker, true)) return;
    setCurrentStep((prevState) => {
      if (prevState === 2) return 2;
      const result = prevState + 1;
      if (result === 1) getService();
      return result;
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const prevStep = () => {
    setCurrentStep((prevState) => {
      if (prevState === 0) return 0;
      const result = prevState - 1;
      if (result === 0) {
        setOrderServices([]);
        setPriceList(undefined);
      }
      return result;
    }),
      window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleSubmit = async () => {
    if (orderServices.length === 0) return;
    const payload: orderBranchPayload = getBranchPayloadFromPackages(packages, orderMethods, orderServices);

    setLoading(true);
    await ApiService.post(
      endpointUrls.submitOrderForBranch,
      // endpointUrls.submitPreOrder,
      { ...payload, traceCode }
    )
      .then((res: any) => {
        if (res?.trackingCodesWithTitles.length > 0) {
          history.push(routes.orderList.path);
        }
      })
      .catch((err: any) => {
        if (typeof err === 'string') {
          //history.push(routes.orderList.path);
          return message.error(err);
        }
        localApiCatcher(errorResponse);
        if (err?.PaymentUrl) {
          if (process.env.REACT_APP_NOD_ENV === 'staging') {
            return message.error('در محیط تست امکان شارژ کیف پول وجود ندارد');
          }
          return location.replace(err.PaymentUrl);
        }
      });

    setLoading(false);
  };

  const getPrice = async () => {
    setPriceLoading(true);
    const payload: pricingV4 = getPayloadPricingV4(packages, orderMethods, orderServices);

    if (!payload) return;
    await ApiService.post(endpointUrls.omV4Pricing, { ...payload })
      .then((res: any) => {
        res && res[0].regularRate?.finalPrice && setPriceList(res[0]);
      })

      .catch(() => {});
    setPriceLoading(false);
  };

  const getService = async () => {
    setSerivceLoading(true);
    const payload: orderPaylaod = getPayloadFromPackages(packages, orderMethods, orderServices);
    if (!payload) return;

    await ApiService.post(endpointUrls.serviceGetOrderServices, { packages: payload.packages })
      .then((res: IBackendGetGeneric<omOrderServices>) =>
        handleApiThenGeneric<IBackendGetGeneric<omOrderServices>, omOrderServices>({
          res,
          notifFail: false,
          notifSuccess: false,
          onSuccessData: (data) => {
            const selectedService = data.map((item) => {
              if (item.serviceList && item.serviceList.length > 0) item.serviceList[0].selected = true;
              return item;
            });
            setOrderServices(selectedService);
          },
          onFailed: () => {
            setSerivceLoading(false);
            setOrderServices([]);
          },
        })
      )
      .catch(() => {
        setSerivceLoading(false);
        setOrderServices([]);
      })
      .finally(() => setSerivceLoading(false));

    return;
  };

  const setSubstationCode = (code: string) => setOrderMethods((prevState) => ({ ...prevState, customerSubstationCode: code }));

  //constants
  const renderPackages = useMemo(
    () =>
      packages.map((pack: packageCreate, index) => (
        <BranchOrderRow
          key={pack.uuid + index}
          deleteRow={deleteRow}
          copyByIndex={copyByIndex}
          index={index}
          pack={pack}
          packages={packages}
          setPackages={setPackages}
          useLocker={isLocker}
        />
      )),
    [packages]
  );
  const stepButtons = (
    <div className='flex gap-2 '>
      {currentStep !== 0 && <TcButton onClick={prevStep}>مرحله قبل</TcButton>}
      {currentStep === 0 && (
        <TcButton type='primary' onClick={nextStep} loading={loading}>
          مرحله بعد
        </TcButton>
      )}
      {currentStep === 1 && !!orderMethods.paymentTypeError && (
        <TcTooltip title={orderMethods.paymentTypeError}>
          <div>
            <TcButton type='primary' disabled={true} onClick={nextStep} loading={orderServices.length === 0 || !priceList}>
              مرحله بعد
            </TcButton>
          </div>
        </TcTooltip>
      )}
      {currentStep === 1 && !orderMethods.paymentTypeError && (
        <TcButton type='primary' onClick={nextStep} disabled={orderServices.length === 0 || !priceList}>
          مرحله بعد
        </TcButton>
      )}
      {currentStep === 2 && (
        <TcButton type='primary' loading={loading} onClick={handleSubmit}>
          ارسال سفارش
        </TcButton>
      )}
    </div>
  );
  // const totalPrice = useMemo(() => {
  //   if (!priceList) return 0;
  //   return orderMethods.paymentTypeId === 30 ? sumFinalAmounts(priceList) + orderCODSum(packages) : sumFinalAmounts(priceList);
  // }, [priceList, packages]);

  return (
    <div className='overflow-hidden'>
      <ParcelOrderSubstation selectedSubstationCode={orderMethods.customerSubstationCode} setSubstationCode={setSubstationCode} />
      <TcPageTitle
        title='ثبت سفارش نمایندگی'
        // moreContent={stepButtons}
      />

      <Steps type='navigation' current={currentStep} items={getOrderSteps(packages, currentStep)} size='small' />
      <div className={`${currentStep !== 0 && 'hidden'} my-6`}>
        {renderPackages}
        {!isLocker && <AddNewOrderRow addNewRow={addNewRow} newReceiverRow={newReceiverRow} />}
      </div>

      <div className={`${currentStep !== 1 && 'hidden'} my-6`}>
        <BranchOrderMethods
          priceLoading={priceLoading}
          serviceLoading={serviceLoading}
          orderMethods={orderMethods}
          setOrderMethods={setOrderMethods}
          orderServices={orderServices}
          setOrderServices={setOrderServices}
          priceList={priceList}
          packages={packages}
          setPackages={setPackages}
          setCashAmount={setCashAmount}
          cashAmount={cashAmount}
        />
      </div>

      <div className={`${currentStep !== 2 && 'hidden'} my-6`}>
        <OrderSummery packages={packages} orderMethods={orderMethods} priceList={priceList} setTraceCode={setTraceCode} traceCode={traceCode} />
      </div>

      <div className=''>
        <TcPageTitle title={<BranchParcelOrderPrice packages={packages} priceList={priceList} loading={priceLoading} haveCOD={orderMethods.haveCOD} />} moreContent={stepButtons} />
      </div>
    </div>
  );
};

export default BranchParcelOrder;
